import { render, staticRenderFns } from "./settingParams.vue?vue&type=template&id=0ca16242&scoped=true&"
import script from "./settingParams.vue?vue&type=script&lang=js&"
export * from "./settingParams.vue?vue&type=script&lang=js&"
import style0 from "./settingParams.vue?vue&type=style&index=0&id=0ca16242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca16242",
  null
  
)

export default component.exports